import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TokenStorageService } from '../services/token-storage.service';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const token = inject(TokenStorageService).token$();
  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        withModuleType: 'true',
      },
    });
  }
  return next(req);
};
